module.exports = vendor_1eab4fd8c9461dcc6069;